import React from 'react';

const Header = () => {
  return (
    <header className="w-full">
      {/* Red progress bar at top */}
      <div className="w-full h-[10px] bg-[#cc0000]" />
    </header>
  );
};

export default Header;